
import { useAuth } from "@/components/AuthProvider";
import { useIsMobile } from "@/hooks/use-mobile";
import { RequiredSubscriptionDialog } from "@/components/subscription/RequiredSubscriptionDialog";
import { DashboardNotifications } from "./header/DashboardNotifications";
import { UserProfileDropdown } from "./header/UserProfileDropdown";
import { MobileMenuToggle } from "./header/MobileMenuToggle";
import { useSubscriptionDialog } from "./header/useSubscriptionDialog";
import { useState, useEffect } from "react";
import { ThemeToggle } from "@/components/shared/ThemeToggle";

export const DashboardHeader = () => {
  const { user, profile } = useAuth();
  const isMobile = useIsMobile();
  const { showRequiredPlan, avatarUrl, isUnpaid } = useSubscriptionDialog(user);
  const [dialogOpen, setDialogOpen] = useState(false);
  
  useEffect(() => {
    if (showRequiredPlan) {
      const timer = setTimeout(() => {
        setDialogOpen(showRequiredPlan);
      }, 1000);
      
      return () => clearTimeout(timer);
    } else {
      setDialogOpen(false);
    }
  }, [showRequiredPlan]);

  return (
    <>
      <header className="fixed top-2 left-2 right-2 h-16 bg-white/95 dark:bg-gray-800/90 backdrop-blur-lg border border-gray-100 dark:border-gray-700/50 z-60 rounded-xl shadow-md transition-all duration-300 hover:shadow-lg mx-2">
        <div className="flex h-full items-center px-3 gap-2 max-w-[1400px] mx-auto">
          {isMobile && <MobileMenuToggle />}
          
          <div className={`${isMobile ? "flex-1 flex items-center" : "flex-1"}`}>
            <div className="flex items-center">
              <img 
                src="/lovable-uploads/a0ac6ad1-1a90-4726-9a01-65aaa671437c.png" 
                alt="Trainerfolio Logo" 
                className={`${isMobile ? "h-10 w-auto" : "h-12 w-auto"}`}
              />
            </div>
          </div>

          <div className="flex items-center gap-3">
            <ThemeToggle />
            <DashboardNotifications userId={user?.id} />
            <UserProfileDropdown userId={user?.email} profile={profile} avatarUrl={avatarUrl} />
          </div>
        </div>
      </header>

      <RequiredSubscriptionDialog open={dialogOpen} isUnpaid={isUnpaid} />
    </>
  );
};
